import SpriteSymbol from "../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../@cultureamp/frontend-svg-util/browser-sprite.js";
var symbol = new SpriteSymbol({
  "id": "ca-icon-start.icon",
  "use": "ca-icon-start.icon-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"ca-icon-start.icon\"><path d=\"M6 4H4v12h2V4ZM9.7 9.17H18v1.66H9.7l2.98 3L11.5 15l-5-5 5-5 1.18 1.18-2.99 2.99Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol